module.exports = __webpack_public_path__ + "static/media/MoreWaysToEarnCK.9bb97edf.png";